export const BALANCE_ERROR_TYPE = {
  DAILY_REMAIN_LIMIT: 'DAILY_REMAIN_LIMIT',
  MONTHLY_REMAIN_LIMIT: 'MONTHLY_REMAIN_LIMIT',
  NEGATIVE_BALANCE: 'NEGATIVE_BALANCE'
};

export const ERROR_REASONS = {
  EMPTY_VALUE: 'EMPTY_VALUE',
  NOT_ENOUGH_BALANCE: 'NOT_ENOUGH_BALANCE',
  NOT_ENOUGH_COUNTERPARTY_BALANCE: 'NOT_ENOUGH_COUNTERPARTY_BALANCE',
  EXCEED_DAILY_LIMIT: 'EXCEED_DAILY_LIMIT',
  EXCEED_MONTHLY_LIMIT: 'EXCEED_MONTHLY_LIMIT',
  EXCEED_PER_TRANSFER_LIMIT: 'EXCEED_PER_TRANSFER_LIMIT',
  SMALLER_THAN_MIN_VALUE_PER_TRANSFER: 'SMALLER_THAN_MIN_VALUE_PER_TRANSFER'
};
